import { useEffect, useState } from 'react';
import { formatPrice } from '../../utils/timedPlayConfig';

export default function ContinueOrderModal({
  open,
  order,
  currentPrice,
  onClose,
  onContinue,
}) {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    const expireRaw = order?.expireTime || order?.roundEndTime;
    if (!open || !expireRaw) {
      return undefined;
    }

    function tick() {
      const expireMs = new Date(String(expireRaw).replace(' ', 'T')).getTime();
      const diff = Math.max(0, Math.floor((expireMs - Date.now()) / 1000));
      setRemaining(diff);
    }

    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [open, order?.expireTime, order?.roundEndTime]);

  if (!open || !order) {
    return null;
  }

  const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
  const seconds = String(remaining % 60).padStart(2, '0');
  const symbolLabel = order.marketSymbolCode?.includes('/')
    ? order.marketSymbolCode
    : `${order.marketSymbolCode}/USDT`;

  return (
    <div className="trade-modal trade-modal--center">
      <button type="button" className="trade-modal__backdrop" aria-label="關閉" onClick={onClose} />
      <div className="trade-modal__panel trade-modal__panel--compact">
        <header className="trade-modal__header">
          <h2>{symbolLabel}</h2>
          <button type="button" className="trade-modal__close" aria-label="關閉" onClick={onClose}>
            ×
          </button>
        </header>

        <div className="trade-continue">
          <div className="trade-continue__ring">
            <div className="trade-continue__timer">{minutes}:{seconds}</div>
            <div className="trade-continue__meta">
              <div><span>開倉價</span><strong>{formatPrice(order.orderPrice)}</strong></div>
              <div><span>現價</span><strong>{formatPrice(currentPrice ?? order.orderPrice)}</strong></div>
            </div>
            <div className="trade-continue__symbol">{symbolLabel}</div>
          </div>
          <button type="button" className="trade-modal__confirm is-ready" onClick={onContinue}>
            繼續下單
          </button>
        </div>
      </div>
    </div>
  );
}
